import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import InsightsCard from '../InsightsCard/InsightsCard';
import PendingRepliesModal from '../PendingRepliesModal/PendingRepliesModal';
import './InstructorInsights.css';
import { axiosInstance } from '../../../utils/tokenUtils';

const InstructorInsights = () => {
  const [insightsData, setInsightsData] = useState({
    averageRating: '0/5',
    favouritedBy: '0 Learners',
    weeklySlotUtilisation: 0,
    totalReviews: 0,
    repliedReviews: 0,
  });
  const [modalOpen, setModalOpen] = useState(false);

  const fetchInsightsData = async () => {
    try {
      const response = await axiosInstance.get('/teachers/insights');
      const data = response.data;

      setInsightsData({
        averageRating: `${data.average_rating || 0}/5`,
        favouritedBy: `${data.favourited_by || 0} Learners`,
        weeklySlotUtilisation: data.weekly_slot_utilisation ?? 0,
        totalReviews: data.total_reviews || 0,
        repliedReviews: data.replied_reviews || 0,
      });
    } catch (error) {
      console.error('Error fetching insights data:', error);
    }
  };

  useEffect(() => {
    fetchInsightsData();
  }, []);

  const handleReplyToPendingReviews = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <Box className="instructor-insights-section">
      <Typography variant="h6" className="instructor-insights-title">
        Instructor's Insights
      </Typography>
      <Box className="instructor-insights-cards">
        <Box className="instructor-insights-card-wrapper">
          <InsightsCard
            title="Average ratings"
            showRating={true}
            rating={insightsData.averageRating}
          />
        </Box>
        <Box className="instructor-insights-card-wrapper">
          <InsightsCard title="Favourited by" value={insightsData.favouritedBy} />
        </Box>
        <Box className="instructor-insights-card-wrapper">
          <InsightsCard
            title="Weekly slot utilisation"
            value={`${Number(insightsData.weeklySlotUtilisation).toFixed(1)}%`}
          />
        </Box>
        <Box className="instructor-insights-card-wrapper">
          <InsightsCard
            title="Replied Reviews"
            value={`${insightsData.repliedReviews} replied of ${insightsData.totalReviews} total`}
            actionText="Reply to Pending reviews"
            onActionClick={handleReplyToPendingReviews}
          />
        </Box>
      </Box>
      <PendingRepliesModal
        open={modalOpen}
        onClose={handleCloseModal}
        onRefreshInsights={fetchInsightsData}
      />
    </Box>
  );
};

export default InstructorInsights;
